(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velosino-carousel"]) return;
  try {
    
  (function () {
    function initCarousel(root) {
      var viewport = root.querySelector('[data-v-carousel-track]')?.parentElement;
      var track = root.querySelector('[data-v-carousel-track]');
      var prev = root.querySelector('[data-v-carousel-prev]');
      var next = root.querySelector('[data-v-carousel-next]');
      if (!viewport || !track) return;

      function slideWidth() {
        var slide = track.querySelector('.v-carousel__slide');
        return slide ? slide.getBoundingClientRect().width + 12 : 260;
      }

      function scrollByAmount(dir) {
        viewport.scrollBy({ left: dir * slideWidth(), behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { scrollByAmount(-1); });
      if (next) next.addEventListener('click', function () { scrollByAmount(1); });

      var autoplay = setInterval(function () {
        var atEnd = viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 4;
        if (atEnd) {
          viewport.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          scrollByAmount(1);
        }
      }, 4500);

      ['pointerdown', 'wheel', 'touchstart'].forEach(function (evt) {
        viewport.addEventListener(evt, function () { clearInterval(autoplay); }, { passive: true, once: true });
      });
    }

    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    ready(function () {
      document.querySelectorAll('[data-v-carousel]').forEach(initCarousel);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velosino-header"]) return;
  try {
    
  // Velosino header — JS mínimo: abrir/cerrar drawer móvil (toggle) y mega-menú al toque.
  (function () {
    function ready(fn) {
      if (document.readyState !== 'loading') fn();
      else document.addEventListener('DOMContentLoaded', fn);
    }

    ready(function () {
      var burger = document.querySelector('[data-v-drawer-toggle]');
      var drawer = document.querySelector('[data-v-drawer]');
      var closers = document.querySelectorAll('[data-v-drawer-close]');

      function openDrawer() {
        drawer.hidden = false;
        burger.setAttribute('aria-expanded', 'true');
      }
      function closeDrawer() {
        drawer.hidden = true;
        burger.setAttribute('aria-expanded', 'false');
      }

      if (burger && drawer) {
        burger.addEventListener('click', function () {
          if (drawer.hidden) {
            openDrawer();
          } else {
            closeDrawer();
          }
        });
        closers.forEach(function (el) {
          el.addEventListener('click', closeDrawer);
        });
      }

      var trigger = document.querySelector('[data-v-mega-trigger]');
      if (trigger) {
        trigger.addEventListener('click', function () {
          var item = trigger.closest('.v-nav__item--has-mega');
          var isOpen = item.classList.toggle('v-mega--open');
          trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
